import { VF_TEXTAREA } from 'AppSrc/core/components/forms/form-base-components/v-f-textarea';
import {
  INLINE_ERRORS,
  commonValidation,
  cleanUpFieldErrors,
  getDefaultFieldErrors,
} from 'AppSrc/core/components/forms/form-base-components/utility/common-validation';
import {
  bizJustCTitle,
  findQuestionsInValue,
  bizJustCFieldId,
} from './business-justification-constants';

const fieldId = bizJustCFieldId;

const validator = (params) => {
  const {
    values,
    field,
  } = params;
  const {
    optional,
  } = field;

  const value = values[fieldId];

  /* MAKE A DEFAULT ERRORS OBJECT */
  const errors = getDefaultFieldErrors();

  /* ERROR CHECKERS */
  const noValue = commonValidation.noValue(value, VF_TEXTAREA);
  const questionsInValue = findQuestionsInValue(value);
  // const hasSpecialCharacter = commonValidation.textInput.hasSpecialCharacter(values[fieldId]);
  /* ADD ERRORS TO ERROR OBJECT */
  errors[INLINE_ERRORS].push((noValue && !optional) ? 'Please enter your answer into the text box' : null);
  errors[INLINE_ERRORS].push(questionsInValue ? questionsInValue : null);
  // errors[INLINE_ERRORS].push((hasSpecialCharacter) ? 'Special character < cannot be accepted in Ace' : null);

  /* REMOVE BLANK ERRORS (because Formik gets confused) */
  return cleanUpFieldErrors(errors);
};

const initialValues = '';

const vFParams = {
  fieldTitle: bizJustCTitle,
  placeholder: 'Enter text',
};

const businessJustificationC = {
  id: fieldId,
  validator,
  initialValues,
  vFParams,
  fieldType: VF_TEXTAREA,
};

export { businessJustificationC };
